<template>
    <div>
        <slot
            name="default"
            v-bind="{
                click,
            }"
        />
        <v-file-input ref="file-input" class="d-none" @change="(file) => upload(file)" />
    </div>
</template>

<script>
import { initUserExchange, USER_EXCHANGE_CODES } from "@/assets/lib";
import XLSX from "xlsx";

export default {
    props: {
        code: { type: String, default: USER_EXCHANGE_CODES.AUCTION.value.toLowerCase() },
    },
    methods: {
        click() {
            this.$refs["file-input"].$refs.input.click();
        },
        upload(file) {
            if (!file) return;

            let code = this.code.toUpperCase();
            let reader = new FileReader();
            let fileName = file.name.split(".");
            if (fileName[fileName.length - 1] !== "xlsx") {
                return alert("엑셀파일만 가능합니다");
            }
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach((sheetName) => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });

                let items = workSheets[0].map((item) => initUserExchange({ code, prev: item["교환권 번호"] }));

                this.$emit("emit", items);
            };
            reader.readAsBinaryString(file);
        },
    },
};
</script>

<style></style>
